import React from 'react';
import { Outlet } from 'react-router-dom';
import { MarketingNavbar } from './MarketingNavbar';
import { MarketingFooter } from './MarketingFooter';
import { RouteSeo } from './RouteSeo';

export const MarketingLayout = () => {
  return (
    <div className="min-h-screen bg-white">
      <RouteSeo />
      <div className="sticky top-0 z-[100]">
        <MarketingNavbar />
      </div>
      <main className="relative z-0">
        <Outlet />
      </main>
      <MarketingFooter />
    </div>
  );
};
